import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PureAbility } from '@casl/ability';
import { Action } from '@bossanova/models';
import { AuthService } from '../services/auth.service';
import { APP_PATHS } from '../app.paths';
import { map } from 'rxjs';

export const adminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const ability = inject(PureAbility);
  const router = inject(Router);

  return authService.checkAuth().pipe(
    map((isAuthenticated) => {
      if (!isAuthenticated) {
        router.navigate(['/', APP_PATHS.LOGIN]);
        return false;
      }

      const canManageAll = ability.can(Action.Manage, 'all');
      if (!canManageAll) {
        router.navigate(['/', APP_PATHS.PROFILE]);
        return false;
      }

      return true;
    }),
  );
};
